import { Controller } from "@hotwired/stimulus"

// Controla o preenchimento dinâmico do select de destino
export default class extends Controller {
  static targets = ["destinoSelect"]

  updateDestinos(event) {
    const tipo = event.target.value
    const select = this.destinoSelectTarget
  const drawflowData = window.currentFlowData || { fases: [], campos: [] }

    let options = []
    if (tipo === "Campo") {
      options = drawflowData.campos.map(p => ({ id: p.temp_id, name: p.titulo }))
    } else if (tipo === "Fase") {
      options = drawflowData.fases.map(f => ({ id: f.temp_id, name: f.nome }))
    }

    select.innerHTML = '<option value="">Selecione destino</option>'
    options.forEach(opt => {
      const o = document.createElement("option")
      o.value = opt.id
      o.textContent = opt.name
      select.appendChild(o)
    })
  }
}
